import { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import { LoginPage } from '../../pages/login'
import {
  useRedirectToLogin,
  useShowMaintenanceModal,
  useCheckAuth,
} from '../../features/users'
import { useClientUpdateNotification } from '../../features/notifications'
import { ThemeProvider } from '@mui/material/styles'
import { ToastProvider } from '../../contexts/ToastContext'
import TMNIndexPage from './pages/index'
import { tmnPortalRoutes } from './pages/portal/routes'
import { useGetTheme } from '../../shared'

const TMNApp: FC = () => {
  useRedirectToLogin()
  useCheckAuth()
  const theme = useGetTheme()
  const MaintenanceModal = useShowMaintenanceModal()
  const { renderNotification } = useClientUpdateNotification()

  return (
    <>
      <ThemeProvider theme={theme}>
        <ToastProvider>
          {MaintenanceModal}
          {renderNotification()}
          <Routes>
            <Route path="/" element={<TMNIndexPage />} />
            <Route path="/login" element={<LoginPage />} />
            {tmnPortalRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </ToastProvider>
      </ThemeProvider>
    </>
  )
}

export default TMNApp
